export const environment = {
  production: false,
  authUrl: `https://login-hml.ciadofrete.com.br`,
  sistemasUrl: `https://sistemas-hml.ciadofrete.com.br/`,
  erpUrl: `https://erp-hml.ciadofrete.com.br/`,
  whatsappUrl: `https://api.whatsapp.com/send?phone=5551981365491&text=.menu`
};